
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64 0C28.7 0 0 28.7 0 64s28.7 64 64 64 64-28.7 64-64S99.3 0 64 0zM49.5 37.1c0-1.1 1.3-2.6 2.3-3.1 10.7-5.1 21.6-10 32.3-15 4.2-1.9 8.2-1.4 11.6 1.7 3.9 3.7 7.7 7.5 11.4 11.5.8.8.9 2.4 1.3 3.6-1.1.3-2.2.6-3.4.9-2.2.5-4.5.7-6.5 1.7-14.8 7-29.6 14.3-44.5 21.4-1.3.6-2.5 1.1-4.6 2.1 0-8.9-.1-16.8.1-24.8zm51.1 48c-5 .2-10 .2-14.9 0-1.1-.1-2.7-1.1-3.2-2.2-4.6-8.8-9-17.7-13.7-27.1 7.4-3.6 14.3-6.9 21.6-10.5 5.4 10.4 10.9 20.4 15.9 30.7 2.1 4.3-.8 8.8-5.7 9.1zm-72-61.5C34.2 19 40 14.9 47.1 13.3v71.6H23.7v-4.4c0-15.4.1-30.7 0-46.1 0-4.5 1.5-8 4.9-10.8zM82 110.2H64.1c-5.8 0-11.7-.4-17.5.1-8.5.7-15.2-2.8-20.7-9.3-2.8-3.4-5.5-6.9-8.1-10.5-.6-.8-.6-2.3-.3-3.2.1-.4 1.7-.5 2.6-.4 2.5.2 5 .8 7.6.8 24 .1 48.1.1 72.1 0 2.8 0 5.6-.6 8.4-.9.8-.1 2.1 0 2.3.4.4.8.4 2.1.1 2.9-4.2 10.8-17.5 20.1-28.6 20.1z"}})])
          )
        }
      }
    